import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import axios from 'axios';
import "./Form.css";
import GrupoServicoFrame from './GrupoServicoFrame';

const { Item: ItemForm } = Form;

export default class ServicoForm extends Component {
  state = {
    registro: {
      serv_descricao: '',
      serv_valor: 0,
      serv_grupo: { key: '' },
      serv_cod_nfse: '',
      serv_cod_nbs: '',
      serv_aliq_nfse: 0,
      serv_descricao_nfse: '',
    },
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        serv_grupo: this.props.registroSelecionado.data.serv_grupo,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {

      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangeCtaCorrente = event => {
    const { registro } = this.state;
    registro['serv_grupo'] = event.serv_grupo;
    this.setState(event);
  }


  onOK = () => {
    if ((!this.state.registro.serv_descricao) || (this.state.registro.serv_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if ((!this.state.registro.serv_grupo) || (this.state.registro.serv_grupo.key === '0') || (this.state.registro.serv_grupo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Grupo', });
      return;
    }
    this.state.registro.serv_grupo = this.state.registro.serv_grupo && this.state.registro.serv_grupo.key ? String(this.state.registro.serv_grupo.key) : null;
    this.props.onSalvarClick(this.state.registro);
  };



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { serv_idf, serv_valor, serv_descricao, serv_grupo, serv_cod_nfse, serv_cod_nbs, serv_aliq_nfse, serv_descricao_nfse } = this.state.registro;

    // console.log('TipoDocForm: ', this.state);

    return (
      <Modal
        title={serv_idf ? "Edição de Serviço" : "Cadastro de Serviço"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"50%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24}>
              <span>Descrição *</span>
              <InputForm
                id="serv_descricao"
                ref="serv_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={serv_descricao}
                validator={value => Boolean(value)}
                errorMessage="Informe a descrição"
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 10 }}>
              <span>Valor</span>
              <InputForm
                type="number"
                id="serv_valor"
                ref="serv_valor"
                value={serv_valor}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={20} style={{ marginTop: -20 }}>
              <GrupoServicoFrame
                label="Grupo *"
                id="serv_grupo"
                value={serv_grupo}
                width={"100%"}
                onChange={this.onChangeCtaCorrente}
                descricaoPrimeiroItem="Informe o Grupo"
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 10 }}>
              <span>Código NFSe</span>
              <InputForm
                id="serv_cod_nfse"
                ref="serv_cod_nfse"
                maxLength={9}
                onChange={this.onChange}
                value={serv_cod_nfse}
                validator={value => Boolean(value)}
                errorMessage="Informe a descrição"
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 10 }}>
              <span>Código NBS</span>
              <InputForm
                id="serv_cod_nbs"
                ref="serv_cod_nbs"
                maxLength={9}
                onChange={this.onChange}
                value={serv_cod_nbs}
                validator={value => Boolean(value)}
                errorMessage="Informe a descrição"
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 10 }}>
              <span>Aliquota NFSe</span>
              <InputForm
                type="number"
                id="serv_aliq_nfse"
                ref="serv_aliq_nfse"
                value={serv_aliq_nfse}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={24} style={{ marginTop: -20 }}>
              <span>Descrição NFSe</span>
              <InputForm
                id="serv_descricao_nfse"
                ref="serv_descricao_nfse"
                maxLength={200}
                onChange={this.onChange}
                value={serv_descricao_nfse}
                validator={value => Boolean(value)}
                errorMessage="Informe a descrição"
              />
            </Col>


          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ServicoForm.js